import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import {
  BrandXXS,
  HeadlineL,
  TypographyVariant,
} from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

const firstStyle = css`
  --text-gradient-color: var(--c-gradient-gold);
  -webkit-text-stroke: 0.5px #c07c26;
`;
const secondStyle = css`
  --text-gradient-color: var(--c-gradient-silver);
  -webkit-text-stroke: 0.5px #757e80;
`;
const thirdStyle = css`
  --text-gradient-color: var(--c-gradient-bronze);
  -webkit-text-stroke: 0.5px #ae6421;
`;

const StyledSpan = styled.span`
  display: inline-flex;
  align-items: start;
  gap: 2px;
  font-family: var(--brand-font);

  &.first {
    ${firstStyle}
  }
  &.second {
    ${secondStyle}
  }
  &.third {
    ${thirdStyle}
  }
`;
const Exposant = styled(BrandXXS)`
  display: inline-flex;
  color: var(--c-nd-600);
  margin-top: var(--half-unit);
`;

type Props = { ranking: number | null; Typography?: TypographyVariant };
export const ContenderRanking = ({
  ranking,
  Typography = HeadlineL,
}: Props) => {
  return (
    <Typography>
      <StyledSpan
        className={classNames({
          first: ranking === 1,
          second: ranking === 2,
          third: ranking === 3,
          'text-gradient-color': ranking && ranking < 4,
        })}
      >
        {typeof ranking === 'number' ? (
          <FormattedMessage
            {...glossary.ordinalStyled}
            values={{
              ordinal: ranking,
              sup: c => <Exposant>{c}</Exposant>,
            }}
          />
        ) : (
          <>
            -<Exposant>%</Exposant>
          </>
        )}
      </StyledSpan>
    </Typography>
  );
};
